// Libraries
import React from 'react'
import Icon from '@mdi/react'

// Components
import { grayscale } from 'styles/colors'
/**
 * @typedef {{
 * path: string,
 * size?: string,
 * color?: string,
 * title?: string,
 * description?: string,
 * spin?: boolean
 * }} AppIconProps
 * @param {AppIconProps} props
 */
const AppIcon = ({
  path,
  size = '1em',
  color = grayscale.gray2,
  title = '',
  description = '',
  spin = false
}) => (
  <Icon
    path={path}
    size={size}
    color={color}
    title={title}
    description={description}
    spin={spin}
  />
)

export default AppIcon
